class LogoSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.logo-slider__viewport');
    this.track = this.querySelector('.logo-slider__track');
    this.originalGroup = this.querySelector('.logo-slider__group');

    if (!this.viewport || !this.track || !this.originalGroup) return;

    this.speed = parseFloat(this.dataset.speed) || 60;

    this.fillTrack();

    // Re-fill when viewport or group size changes (images loading, window resize, etc.)
    this.resizeObserver = new ResizeObserver(() => this.scheduleFill());
    this.resizeObserver.observe(this.viewport);
    this.resizeObserver.observe(this.originalGroup);
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.fillTimeout) clearTimeout(this.fillTimeout);
  }

  scheduleFill() {
    clearTimeout(this.fillTimeout);
    this.fillTimeout = setTimeout(() => this.fillTrack(), 100);
  }

  fillTrack() {
    // Remove any existing clones before re-measuring
    this.track.querySelectorAll('[data-clone="true"]').forEach((clone) => clone.remove());

    const viewportWidth = this.viewport.offsetWidth;
    const groupWidth = this.originalGroup.offsetWidth;

    if (groupWidth === 0 || viewportWidth === 0) return;

    // Need enough groups so the track always overflows by at least one extra group.
    // Minimum of 2 so the loop has something to slide into.
    const groupCount = Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1);

    for (let i = 1; i < groupCount; i++) {
      const clone = this.originalGroup.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.clone = 'true';
      clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      this.track.appendChild(clone);
    }

    // CSS animates by -100% / groupCount = exactly one group's width, for a seamless loop.
    this.style.setProperty('--logo-slider-groups', groupCount);

    // Duration = time to scroll one group's worth of pixels at the configured speed.
    const duration = groupWidth / this.speed;
    this.style.setProperty('--logo-slider-duration', `${duration}s`);

    // Marker for CSS: only animate once JS has set everything up correctly.
    this.setAttribute('data-ready', '');
  }
}

if (!customElements.get('logo-slider')) {
  customElements.define('logo-slider', LogoSlider);
}
